export default {
  default: () => import("/home/stcomuser/htdocs/satyatunes.com/layouts/default.vue"),
  nonewsletter: () => import("/home/stcomuser/htdocs/satyatunes.com/layouts/nonewsletter.vue")
}